'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Loyalty = void 0;
var transport_1 = require("../../transport");
var Loyalty = /** @class */ (function () {
    function Loyalty() {
    }
    Loyalty.prototype.userProgress = function (params) {
        return transport_1.transport.request('loyalty/userProgress', params);
    };
    Loyalty.prototype.history = function () {
        return transport_1.transport.request('loyalty/history');
    };
    Loyalty.prototype.rank = function (params) {
        return transport_1.transport.request('loyalty/rank', params);
    };
    return Loyalty;
}());
exports.Loyalty = Loyalty;
